// 评选
export default [
  {
    path: '/appraise-elect/ae-student-office',
    component: resolve => require(['@/pages/appraise-elect/ae-students-office/appraise-elect.vue'], resolve),
    name: 'appraise-elect',
    meta: {
      title: '奖学金评选(处)'
    }
  },
  {
    path: '/appraise-elect/ae-institute',
    component: resolve => require(['@/pages/appraise-elect/ae-institute/appraise-elect-institute.vue'], resolve),
    name: 'appraise-elect-institute',
    meta: {
      title: '奖学金评选(院)'
    }
  },
  {
    path: '/appraise-elect/ae-institute/check-list',
    component: resolve => require(['@/pages/appraise-elect/ae-institute/ae-student-list.vue'], resolve),
    name: 'ae-student-list',
    meta: {
      title: '查看名单'
    }
  },
  {
    path: '/appraise-elect/ae-student-office/ae-institute-result',
    component: resolve => require(['@/pages/appraise-elect/ae-students-office/ae-institute-result.vue'], resolve),
    name: 'ae-institute-result',
    meta: {
      title: '学院测评结果'
    }
  },
  {
    path: '/appraise-elect/ae-instructor',
    component: resolve => require(['@/pages/appraise-elect/ae-instructor/appraise-elect-instructor.vue'], resolve),
    name: 'appraise-elect-instructor',
    meta: {
      title: '奖学金评选(辅导员)'
    }
  },
  {
    path: '/appraise-elect/ae-instructor/ae-instructor-result',
    component: resolve => require(['@/pages/appraise-elect/ae-instructor/ae-instructor-result.vue'], resolve),
    name: 'ae-instructor-result',
    meta: {
      title: '辅导员评选结果'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/appraiseElect.js